var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"92125530abd0dac5b80742ff2d39aa16d8a9d08c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["company-portal@aydi"]={id:"92125530abd0dac5b80742ff2d39aa16d8a9d08c"};
      